export default "__VITE_ASSET__CgbeY6pW__"